// extracted by mini-css-extract-plugin
export default {"button":"Z71Yd","primary":"DYXqt","secondary":"zJ4lZ","text":"Ruq8n","small":"KI6CD","icon":"e2Jjb","square":"VsUVM","rounded":"X1MwM","disabled":"h6oed","flex":"WjtMB"};